import * as React from 'react';
import { styled } from '@mui/material/styles';
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp';
import MuiAccordion from '@mui/material/Accordion';
import MuiAccordionSummary, { accordionSummaryClasses } from '@mui/material/AccordionSummary';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';

/* __next_internal_client_entry_do_not_use__ default auto */ import { createDemoClient } from '@mui/internal-core-docs/utils/createDemoClient';
const ClientProvider = createDemoClient(import.meta.url, { precompute: { externals: { react: React, "@mui/material/styles": { styled }, "@mui/icons-material/ArrowForwardIosSharp": ArrowForwardIosSharpIcon, "@mui/material/Accordion": MuiAccordion, "@mui/material/AccordionSummary": MuiAccordionSummary, "@mui/material/AccordionDetails": MuiAccordionDetails, "@mui/material/Typography": Typography } } });
export default ClientProvider;
